import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts"

interface EMIChartProps {
  principal: number
  interest: number
}

export default function EMIChart({ principal, interest }: EMIChartProps) {
  const data = [
    { name: "Principal", value: principal, color: "#1a56db" },
    { name: "Interest", value: interest, color: "#0ea5e9" },
  ]

  const total = principal + interest
  const principalPercent = total > 0 ? Math.round((principal / total) * 100) : 0
  const interestPercent = total > 0 ? 100 - principalPercent : 0

  return (
    <div className="flex items-center gap-4">
      <div className="w-32 h-32 flex-shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={30}
              outerRadius={55}
              paddingAngle={2}
              dataKey="value"
              strokeWidth={0}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number) => `\u20B9${value.toLocaleString("en-IN")}`}
              contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-blue-700" />
          <span className="text-xs text-slate-600">Principal ({principalPercent}%)</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-sky-500" />
          <span className="text-xs text-slate-600">Interest ({interestPercent}%)</span>
        </div>
      </div>
    </div>
  )
}
